module.exports = __webpack_public_path__ + "static/media/values.774e783b.jpg";